module.exports = __webpack_public_path__ + "static/media/KeyboardIcon.280f9ade.svg";